import {Button, Divider, Stack} from '@mui/material';
import React, {Fragment, PropsWithChildren} from 'react';

import {useMediaQueries} from 'presentation/pages';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {LocationWrapper} from './styles';
import {SelectionLocationContainerProps} from './types';

const {orientationCard} = translations['pt-br'].privateFlow.profile.locationSelection;

export function SelectLocationContainer({
	children,
	customOrientationText,
	handleOpenModal,
	flowType,
	buttonDataTagId,
}: PropsWithChildren<SelectionLocationContainerProps>) {
	const {isLaptop} = useMediaQueries();
	const isAuthorizationFlow = flowType === FlowEnum.AUTHORIZATIONS;

	return (
		<Stack alignItems="center">
			<Stack width={isLaptop ? '100%' : 618}>
				<LocationWrapper>
					{children}
					{isAuthorizationFlow ? null : (
						<Fragment>
							<Divider />
							<Stack alignItems={'end'}>
								<Button
									data-tag-id={buttonDataTagId}
									variant="outlined"
									size="large"
									fullWidth={isLaptop}
									onClick={handleOpenModal}>
									{customOrientationText ?? orientationCard}
								</Button>
							</Stack>
						</Fragment>
					)}
				</LocationWrapper>
			</Stack>
		</Stack>
	);
}
